export default {
  brand: '品牌後台',
  dashboard: '數據看板',
  products: '產品管理',
  antiFake: '防偽管理',
  scanTemplate: '掃碼模板',
  scanTemplateEditor: '模板編輯器',
  supplyChain: '供應鏈管理',
  production: '生產管理',
  members: '會員管理',
  memberList: '會員列表',
  memberDetail: '會員詳情',
  memberLevelPrivilege: '會員等級特權',
  memberDecoration: '會員裝修',
  blacklistManagement: '黑名單管理',
  memberManagement: '會員管理',
  memberBasicConfig: '基礎設置',
  points: '積分',
  pointsIssueDetail: '發放明細',
  pointsIssueStats: '發放統計',
  pointsConfig: '積分配置',
  marketing: '行銷活動',
  activityManagement: '活動管理',
  activityList: '活動列表',
  activityAdd: '建立活動',
  activityEdit: '編輯活動',
  activityDetail: '活動詳情',
  drawRecord: '開獎記錄',
  giftClaimRecord: '禮品領取記錄',
  activityTemplate: '活動模板',
  marketingData: '營銷數據',
  mall: '積分商城配置',
  pointsMall: '積分商城',
  pointsProduct: '積分商品',
  pointsProductAddEdit: '添加/編輯禮品',
  pointsProductCategory: '商品分類',
  exchangeRecord: '兌換記錄',
  mallDecoration: '商城裝修',
  exchangeStats: '兌換統計',
  dealers: '經銷商管理',
  settings: '品牌設置',
  reports: '數據報表',
  code: '防偽碼管理',
  codeManagement: '碼管理',
  codeBatchList: '碼批次列表',
  codeStatusControl: '碼狀態控制',
  antiFakeTrace: '防偽溯源',
  productLinkTemplate: '產品關聯模板',
  scanDetail: '掃碼明細',
  alertRecord: '預警記錄',
  alertSetting: '預警設置',
  productCodeAssignment: '產品賦碼',
  merchants: '商戶管理',
  companyInfo: '企業信息',
  emailConfig: '郵箱配置',
  smsConfig: '短信配置',
  i18nManagement: '多語言管理',
  paymentAuthConfig: '支付與授權配置',
  systemSettings: '系統設置',
  roleManagement: '角色管理',
  accountManagement: '賬號管理',
  operationLog: '操作日誌',
  afterSaleFeedback: '售後反饋',
  productLibrary: '產品庫',
  productList: '產品列表',
  productAdd: '添加產品',
  productEdit: '編輯產品',
  productCategory: '產品分類',
  productAttribute: '產品屬性',
  giftLibrary: '禮品庫',
  giftList: '禮品列表',
  giftAdd: '添加禮品',
  giftEdit: '編輯禮品',
  giftCategory: '禮品分類',
  productionInfo: '生產資訊',
  productionBatch: '生產批次',
  batchAdd: '添加生產批次',
  batchEdit: '編輯生產批次',
  factoryManagement: '工廠管理',
  materialLibrary: '素材庫',
  memberLevelAdd: '添加會員等級',
  memberLevelEdit: '編輯會員等級',
};
